import React, { useEffect, useState } from "react";
import useUser from "../../hooks/useUser";
import {
  LocalCreateLogin,
  LocalLogin,
  ResetPassword,
} from "../../actions/Signin";
import RoundedButton from "../Layout/Buttons/RoundedButton";
import { TextField } from "@fluentui/react";
import "./Auth.scss";
import { Toast, ToastBody, ToastTitle, useToastController } from '@fluentui/react-components';
import { ssToast } from "ss-lib";

const ScholarSiftLogin = (props) => {
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [email, setEmail] = useState(props?.email);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState();
  const { saveUser } = useUser();
  const [creatingLogin, setCreatingLogin] = useState(false);
  const { dispatchToast } = useToastController(ssToast);
  
  useEffect(() => {
    setEmail(props.email);
  }, [props.email])

  useEffect(() => {
    if (email && email.length) checkEmail(email);
  }, [email]);

  const checkEmail = (v) => {
    if (v === undefined || v === 0) {
      return "";
    }
    let at = v.indexOf("@");
    if (at === -1) {
    //  setEmail(undefined);
      return "Please enter a valid email address";
    }
    let dom = v.lastIndexOf(".");
    let isValid =
      dom > at && at > 0 && dom < v.length - 2 && v.indexOf(" ") === -1;
    if (!isValid) {
   //   setEmail(undefined);
      return "Please enter a valid email address";
    }
    setEmail(v);
  };

  const checkPass = (v, key) => {
    if (props.createMode && (v === undefined || v.length < 8)) {
      if (key === "password") setPassword(undefined);
      else if (key === "confirm") setConfirm(undefined);
      return "Must be at least 8 characters long";
    }
    if (key === "password") setPassword(v);
    else if (key === "confirm") {
      if (v !== password) {
        setConfirm(undefined);
        return "Passwords do not match";
      }
      setConfirm(v);
    }
  };

  const checkExec = (e) => {
    if (e.keyCode === 13) Submit();
  };

  const checkName = (v, key) => {
    if (v.length < 2) {
      if (key === "first") setFirst(undefined);
      else setLast(undefined);
      return "Must be at least two characters";
    }
    if (key === "first") setFirst(v);
    else setLast(v);
  };

  const Submit = () => {
    if (!email) {
      setError("Please enter a valid email address");
      return;
    }

    if (props.createMode) {
      if (!first || first.length < 2) {
        setError("First Name must be at least two characters");
        return;
      }
      if (!last || last.length < 2) {
        setError("Last Name must be at least two characters");
        return;
      }
      if (!password || password.length < 8) {
        setError("Must be at least 8 characters");
        return;
      }
      if (password !== confirm) {
        setError("Passwords do not match");
        return;
      }


      if(!creatingLogin) {
        setCreatingLogin(true);
        dispatchToast(<Toast appearance='inverted'><ToastTitle>Login Info</ToastTitle><ToastBody>Creating Account</ToastBody></Toast>, {intent: "information"});
        LocalCreateLogin(
          email,
          password,
          first,
          last,
          (v) => {dispatchToast(<Toast appearance='inverted'><ToastTitle>Login Info</ToastTitle><ToastBody>{v}</ToastBody></Toast>, {intent: "success"}); setCreatingLogin(false)},
          (v) => {props.setError(v); setCreatingLogin(false)}
        );
      }
    } else {
      setError("");
      LocalLogin(
        email,
        password,
        saveUser,
        props.finishLogin,
        props.showLoader,
        props.setInfo,
        (v) => {
          setError(v);
          props.setError(v);
        }
      );
    }
  };

  const ResetPW = (notice, msg) => {
    if (!email) return;
    dispatchToast(<Toast appearance='inverted'>{notice ? notice : "Sending Password Reset Email"}</Toast>,{intent:"information"});
    ResetPassword(email, msg, (result, intent) => {
      dispatchToast(<Toast appearance='inverted'><ToastBody>{result}</ToastBody></Toast>, {intent: intent})
    });
  };

  return (
    <>
      {
        props.createMode ? 
        <div className="signin-title">Sign up with ScholarSift</div> :
        <div className="signin-title">Sign in</div>
      }
      <TextField
        validateOnLoad={false}
        styles={{
          errorMessage: {
            color: "var(--berry)",
            fontSize: 14,
          },
          fieldGroup: {
            borderRadius: 20,
            width: 250,
            marginBottom: 5,
            marginTop: 15,
          },
        }}
        borderless
        placeholder="  Email"
        required
        value={email ? email : ""}
        onGetErrorMessage={checkEmail}
        onChange={(ev, val) => setEmail(val)}
      />
      <TextField
        validateOnLoad={false}
        styles={{
          errorMessage: {
            color: "var(--berry)",
            fontSize: 14,
          },
          fieldGroup: {
            borderRadius: 20,
            width: 250,
            marginBottom: 5,
            marginTop: 15,
          },
        }}
        borderless
        placeholder="  Password"
        required
        type="password"
        canRevealPassword
        revealPasswordAriaLabel="Show password"
        onGetErrorMessage={(v) => {
          return checkPass(v, "password");
        }}
        onKeyDown={e => { if(!props.createMode) checkExec(e) }}
        onChange={(ev, val) => {setPassword(val)}}
      />
      {props.createMode && (
        <>
          <TextField
            validateOnLoad={false}
            styles={{
              errorMessage: {
                color: "var(--berry)",
                fontSize: 14,
              },
              fieldGroup: {
                borderRadius: 20,
                width: 250,
                marginBottom: 5,
                marginTop: 15,
                userFocus: { borderRadius: 20, width: 250, marginBottom: 5 },
              },
            }}
            borderless
            placeholder="  Confirm Password"
            required
            type="password"
            canRevealPassword
            revealPasswordAriaLabel="Show password"
            onGetErrorMessage={(v) => {
              return checkPass(v, "confirm");
            }}
          />
          <TextField
            validateOnLoad={false}
            styles={{
              errorMessage: {
                color: "var(--berry)",
                fontSize: 14,
              },
              fieldGroup: {
                borderRadius: 20,
                width: 250,
                marginBottom: 5,
                marginTop: 15,
              },
            }}
            borderless
            placeholder="  First Name"
            required
            onGetErrorMessage={(v) => {
              return checkName(v, "first");
            }}
          />
          <TextField
            validateOnLoad={false}
            styles={{
              errorMessage: {
                color: "var(--berry)",
                fontSize: 14,
                marginBottom: 20,
              },
              fieldGroup: {
                borderRadius: 20,
                width: 250,
                marginBottom: 5,
                marginTop: 15,
              },
            }}
            borderless
            placeholder="  Last Name"
            required
            onKeyDown={checkExec}
            onGetErrorMessage={(v) => {
              return checkName(v, "last");
            }}
          />
          <div className="login-item">
            You will need to verify your email address
          </div>
        </>
      )}
      {error && error.length && (
        <div className="login-item">
          {error.indexOf("Incorrect password") > -1 ? (
            <div
              className="login-create"
              aria-label="reset password"
              onClick={ResetPW}
            >
              Reset Password
            </div>
          ) : (
            <div className="login-error">{error.indexOf("Account has not been verified") > -1 ? <div>Please verify your email address. Check or inbox or <a href="#" onClick={() => {ResetPW("Resending Verification Email", "Verification email sent to:");}}>click here</a> to resend</div> : error}</div>
          )}
        </div>
      )}

      <RoundedButton
        id="signin-button"
        onClick={() => {Submit()}}
        aria-label="submit"
        title={props.createMode ? "Create" : "Submit"}
      />
      <div
        className="signin-redirect"
        aria-label={props.createMode ? "Sign in" : "Create Account"}
        onClick={() => {
          props.setCreateMode(!props.createMode);
        }}
      >
        {props.createMode ? "Sign in" : "Create Account"}
      </div>
    </>
  );
};

export default ScholarSiftLogin;
